import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Factor from "./Factor";
import PersonCard from "./PersonCard";
import GridConfig from "./GridConfig";

export default class Factors extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'factor',
            data: null,
            loading: true,
            configName: 'factors_grid',
            moduleName: 'فاکتورها',
            filters: {
                type: props.Type
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        if (props.Type == this.state.filters.type) return;
        this.state.filters.type = props.Type;
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Factor Type={this.state.filters.type} Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Factor Type={this.state.filters.type} Caller={this} /> });
    }
    showPersonCard(id) {
        this.showComponents({ component: <PersonCard Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "number", caption: "شماره", show: true },
                { field: "number2", caption: "ارجاع", show: true },
                { field: "personName", caption: "فروشنده/خریدار", show: true },
                { field: "dateString", caption: "تاریخ", show: true },
                { field: "total", caption: "مبلغ", show: true },
                { field: "remain", caption: "باقی مانده", show: true },
                { field: "total2", caption: "مبلغ ارزی", show: true },
                { field: "remain2", caption: "باقی مانده ارزی", show: true },
                { field: "statusString", caption: "وضعیت", show: true },
                { field: "note", caption: "یادداشت", show: false },
                { field: "tprdis", caption: "مجموع قبل از تخفیف", show: false },
                { field: "tdis", caption: "مجموع تخفیف", show: false },
                { field: "tvam", caption: "مجموع مالیات", show: false },
                { field: "finalDiscountPrice", caption: "تخفیف نهایی", show: false },
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.number}</a> } });
            if (f.field == 'number2' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'personName' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showPersonCard(props.data.personId)}>{props.data.personName}</a> } });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'total' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.total) } });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'total2' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.total2) } });
            if (f.field == 'remain2' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain2) } });
            if (f.field == 'sourceString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'statusString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'note' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'tprdis' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.tprdis) } });
            if (f.field == 'tdis' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.tdis) } });
            if (f.field == 'tvam' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.tvam) } });
            if (f.field == 'finalDiscountPrice' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.finalDiscountPrice) } });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });

        return t;
    }
    renderForm() {
        return <div className="container">
            {this.getToolBar(false)}
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}